import { createFileRoute } from '@tanstack/react-router';
import ProvidersPage from '@/pages/setup/ProvidersPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export interface ProvidersSearch {
  /** Active provider opened in the detail/edit sheet. */
  id?: string;
  /** Inactive provider opened in the read-only reactivate sheet. */
  inactiveId?: string;
  /** Selected tab. Defaults to 'active'; auto-switches to 'inactive' when inactiveId is present. */
  tab?: 'active' | 'inactive';
}

export const Route = createFileRoute('/_authenticated/setup/providers')({
  beforeLoad: () => requireSetupPageAccess('/setup/providers'),
  validateSearch: (raw: Record<string, unknown>): ProvidersSearch => ({
    id: (raw.id as string) ?? undefined,
    inactiveId: (raw.inactiveId as string) ?? undefined,
    tab: raw.tab === 'inactive' ? 'inactive' : raw.tab === 'active' ? 'active' : undefined,
  }),
  component: ProvidersPage,
});
